import { render, staticRenderFns } from "./LinkForm.vue?vue&type=template&id=5ce200f7&scoped=true&"
import script from "./LinkForm.vue?vue&type=script&lang=js&"
export * from "./LinkForm.vue?vue&type=script&lang=js&"
import style0 from "./LinkForm.vue?vue&type=style&index=0&id=5ce200f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce200f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardTitle,VContainer,VForm,VSelect,VTextField})
